module.exports = "# Hey\n\n<ReactPlayer url='https://www.youtube.com/watch?v=ysz5S6PUM-U' controls/>\n"